import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
    addSkillDevelopmentAdmin,
    deleteSkillDevelopmentAdmin,
    fetchSkillDevelopmentAdmin,
    updateSkillDevelopmentAdmin,
} from "./SkillDevelopmentAdminAPI";

export const fetchSkillDevelopmentAdminasync = createAsyncThunk(
    "skillDevelopmentAdmin/fetch",
    async (_, { rejectWithValue }) => {
        try {
            return await fetchSkillDevelopmentAdmin();
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const addSkillDevelopmentAdminAsync = createAsyncThunk(
    "skillDevelopmentAdmin/add",
    async (newSkillDevelopment, { rejectWithValue }) => {
        try {
            return await addSkillDevelopmentAdmin(newSkillDevelopment);
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

// UPDATED: accept { uuid, data } and support FormData (POST + _method=PUT in API)
export const updateSkillDevelopmentAdminAsync = createAsyncThunk(
    "skillDevelopmentAdmin/update",
    async ({ uuid, data }, { rejectWithValue }) => {
        try {
            return await updateSkillDevelopmentAdmin(uuid, data);
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const deleteSkillDevelopmentAdminAsync = createAsyncThunk(
    "skillDevelopmentAdmin/delete",
    async (uuid, { rejectWithValue }) => {
        try {
            return await deleteSkillDevelopmentAdmin(uuid);
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

const SkillDevelopmentAdminSlice = createSlice({
    name: "skillDevelopmentAdmin",
    initialState: {
        data: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Fetch
            .addCase(fetchSkillDevelopmentAdminasync.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchSkillDevelopmentAdminasync.fulfilled, (state, action) => {
                state.loading = false;
                state.data =
                    action.payload?.response ??
                    action.payload?.data?.response ??
                    [];
            })
            .addCase(fetchSkillDevelopmentAdminasync.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // Add
            .addCase(addSkillDevelopmentAdminAsync.pending, (state) => {
                state.loading = true;
            })
            .addCase(addSkillDevelopmentAdminAsync.fulfilled, (state, action) => {
                state.loading = false;
                const server = action.payload?.response ?? action.payload?.data ?? null;
                if (!server) return;
                if (Array.isArray(server)) state.data.unshift(...server);
                else state.data.unshift(server);
            })
            .addCase(addSkillDevelopmentAdminAsync.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // Update
            .addCase(updateSkillDevelopmentAdminAsync.pending, (state) => {
                state.loading = true;
            })
            .addCase(updateSkillDevelopmentAdminAsync.fulfilled, (state, action) => {
                state.loading = false;
                const { uuid, data: patch } = action.meta.arg;
                const server = action.payload?.response ?? action.payload?.data ?? null;

                const idx = state.data.findIndex(
                    (i) => i?.uuid === uuid || i?.id === uuid
                );
                if (idx === -1) return;

                if (server && (server.uuid || server.id)) {
                    state.data[idx] = server;
                } else {
                    // Only patch if plain object
                    const canPatch =
                        patch && !(typeof FormData !== "undefined" && patch instanceof FormData);
                    if (canPatch) {
                        state.data[idx] = { ...state.data[idx], ...patch };
                    }
                }
            })
            .addCase(updateSkillDevelopmentAdminAsync.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // Delete
            .addCase(deleteSkillDevelopmentAdminAsync.pending, (state) => {
                state.loading = true;
            })
            .addCase(deleteSkillDevelopmentAdminAsync.fulfilled, (state, action) => {
                state.loading = false;
                const uuid = action.meta.arg;
                state.data = state.data.filter(
                    (item) => item.uuid !== uuid && item.id !== uuid
                );
            })
            .addCase(deleteSkillDevelopmentAdminAsync.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const selectSkillDevelopmentAdmin = (state) =>
    state.skillDevelopmentAdmin.data;
export const selectSkillDevelopmentLoading = (state) =>
    state.skillDevelopmentAdmin.loading;

export default SkillDevelopmentAdminSlice.reducer;